import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { ChartistModule } from 'ng-chartist';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbDatepickerModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { BlockUIModule } from 'ng-block-ui';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BlockTemplateComponent } from 'src/app/_layout/blockui/block-template.component';
import { BreadcrumbModule } from 'src/app/_layout/breadcrumb/breadcrumb.module';
import { CardModule } from '../../partials/general/card/card.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomLoaderModule } from 'src/app/CustomLoader/custom-loader/custom-loader.module';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AllrentinvoiceComponent } from './allrentinvoice/allrentinvoice.component';
import { ViewrentinvoiceComponent } from './viewrentinvoice/viewrentinvoice.component';
import { RentinvoiceComponent } from './rentinvoice/rentinvoice.component';

@NgModule({
  declarations: [AllrentinvoiceComponent, ViewrentinvoiceComponent, RentinvoiceComponent],
  imports: [
    CommonModule,
    CustomLoaderModule,
    // ChartistModule,
    FormsModule,
    NgSelectModule,
    NgxDatatableModule,
    AutocompleteLibModule,
    PerfectScrollbarModule,
    NgbModule,
    PdfViewerModule,
    // NgbDatepickerModule.forRoot(),
    // NgbDatepickerModule.forRoot(),
    // NgbModalModule.forRoot(),
    BreadcrumbModule,
    CardModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    RouterModule.forChild([
      {
        path:"add",
        component:RentinvoiceComponent
      
      },
      {
        path:"all",
        component:AllrentinvoiceComponent
      
      },
      {
        path:"viewrentbill",
        component:ViewrentinvoiceComponent
      
      },
    
    ]),
    NgxSpinnerModule
    
  ],

})
export class RentandrepairModule { }
